/**
 * Builds a deterministic cache key from an action ID and its parameters.
 *
 * Keys are stable regardless of object key insertion order — params are
 * sorted alphabetically before serialization.
 */
export function buildCacheKey(actionId: string, params: Record<string, string>): string {
  const sortedEntries = Object.keys(params)
    .sort()
    .map((k) => `${k}=${params[k]}`);

  if (sortedEntries.length === 0) return actionId;
  return `${actionId}::${sortedEntries.join('&')}`;
}
